/**
 * Utility functions for checking desk event ownership
 */

/**
 * Check if current user can manage desk events for a specific employee
 * @param {Object} currentEmployee - Current user's employee record
 * @param {Object} currentUser - Current user object
 * @param {boolean} canBookForOthers - Whether user can book for others
 * @returns {boolean}
 */
export function canManageEmployeeDeskEvents(currentEmployee, currentUser, canBookForOthers) {
  if (canBookForOthers) {
    return true
  }

  if (!currentUser || !currentEmployee) {
    return false
  }

  return currentUser.email === currentEmployee.email.toLowerCase()
}
